import i18next from 'i18next'

import { isReadOnly } from '~/helpers'

type AdTypesOption = {
  type: CampaignType
} & RadioOptionProps<CampaignAdType>

const getAdTypesOptions = (): AdTypesOption[] => [
  {
    id: `type_product`,
    name: `type_product`,
    value: 'product',
    label: i18next.t(`rm:productAds`),
    type: 'on_site',
    description: i18next.t('rm:adTypes.create.product.description'),
    disabled: isReadOnly()
  },
  {
    id: `type_banner`,
    name: `type_banner`,
    value: 'banner',
    label: i18next.t(`rm:Banner`),
    type: 'on_site',
    description: i18next.t('rm:adTypes.create.banner.description'),
    disabled: isReadOnly()
  },
  {
    id: `type_banner_video`,
    name: `type_banner_video`,
    value: 'banner_video',
    label: i18next.t(`rm:Video`),
    type: 'on_site',
    description: i18next.t('rm:adTypes.create.banner_video.description'),
    disabled: isReadOnly()
  },
  {
    id: `type_sponsored_brand`,
    name: `type_sponsored_brand`,
    value: 'sponsored_brand',
    label: i18next.t(`rm:sponsoredBrand`),
    type: 'on_site',
    description: i18next.t('rm:adTypes.create.sponsored_brand.description'),
    disabled: isReadOnly()
  },
  {
    id: `type_sponsored_brand_video`,
    name: `type_sponsored_brand_video`,
    value: 'sponsored_brand_video',
    label: i18next.t(`rm:sponsoredBrandVideo`),
    type: 'on_site',
    description: i18next.t(
      'rm:adTypes.create.sponsored_brand_video.description'
    ),
    disabled: isReadOnly()
  },
  {
    id: `type_digital_signage`,
    name: `type_digital_signage`,
    value: 'digital_signage',
    label: i18next.t(`rm:digitalSignage`),
    type: 'in_store',
    description: i18next.t('rm:adTypes.create.digital_signage.description'),
    disabled: isReadOnly()
  },
  {
    id: `type_banner_off_site`,
    name: `type_banner_off_site`,
    value: 'banner_off_site',
    label: i18next.t(`rm:bannerOffsite`),
    type: 'off_site',
    description: i18next.t('rm:adTypes.create.banner_offsite.description'),
    disabled: isReadOnly()
  }
]

export const adTypesOptions: AdTypesOption[] = getAdTypesOptions()
